import React, { useEffect } from 'react';
import clsx from 'clsx';
import { ReactComponent as ChevronDown } from 'icons/chevron-down.svg';
import { useState } from 'react';
import { useRef } from 'react';

const SelectFieldVariants = ({ data, onClick, className, style, disable, placeholder, value }) => {
  const dropdownRef = useRef(null);
  const [isShowDropdown, setIsShowDropdown] = useState(false);

  useEffect(() => {
    // Add a click event listener to the document to handle clicks outside the dropdown.
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsShowDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      // Remove the event listener when the component unmounts.
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsShowDropdown(!isShowDropdown);
  };

  const clickHandler = (item) => {
    onClick(item);
    // setIsShowDropdown(false);
  };

  return (
    <div className={clsx('select-field-variants', className)} style={style} ref={dropdownRef}>
      <div className={clsx('select-field-variants__field', disable ? 'disable' : '')} onClick={toggleDropdown}>
        <div className="select-field-variants__field__input">{value ? value : placeholder}</div>
        <ChevronDown className={`select-field-variants__field__chevron ${isShowDropdown ? 'down' : ''}`} />
      </div>

      {/* drop down */}
      {isShowDropdown && (
        <ul className="select-field-variants__field__dropdown">
          {data ? (
            data.map((item) => (
              <li
                key={item.id}
                style={{ padding: '12px 14px' }}
                className={clsx('list-variants', item.available_stock === 0 ? 'disable' : '')}
                onClick={() => clickHandler(item)}
              >
                <p>{item.color}</p>
              </li>
            ))
          ) : (
            <li>Data Not Found</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SelectFieldVariants;
